/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import logo from "../assets/astra_hack_logo.png";
import { UserAuth } from "../../context/authContext";
import { Link, useLocation } from "react-router-dom";
import { FiMenu, FiX, FiLogOut, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { user, logout } = UserAuth();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "#about" },
    { name: "Features", path: "#features" },
    { name: "Faq", path: "#faq" },
  ];

  if (user && user.email) {
    navLinks.push({ name: "Dashboard", path: "/dashboard" });
  }

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "glass-panel bg-background/80 py-3 shadow-glass" : "bg-transparent py-5"
        }`}
      >
        <div className="container mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2 group">
              <div className="w-12 h-12 relative overflow-hidden rounded-full border-2 border-primary/20 group-hover:border-primary transition-colors">
                <img src={logo} alt="AstraHack" className="w-full h-full object-cover" />
              </div>
              <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-400 group-hover:from-primary group-hover:to-secondary transition-all">
                AstraHack
              </span>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.path}
                  className={`text-sm font-medium transition-colors hover:text-primary ${
                    location.pathname === link.path ? "text-primary" : "text-muted"
                  }`}
                >
                  {link.name}
                </a>
              ))}
            </nav>

            {/* Auth Buttons */}
            <div className="hidden md:flex items-center gap-4">
              {!user || !user.email ? (
                <Link
                  to="/login"
                  className="btn-primary flex items-center gap-2 text-sm px-5 py-2.5"
                >
                  Sign In
                </Link>
              ) : (
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 text-sm font-medium text-muted hover:text-red-400 transition-colors px-4 py-2 rounded-lg hover:bg-white/5 border border-transparent hover:border-white/10"
                >
                  <FiLogOut /> Logout
                </button>
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="md:hidden text-2xl text-white p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden glass-panel absolute top-full left-0 right-0 p-4 border-t border-white/10 flex flex-col gap-4 animate-fadeIn">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`text-lg font-medium py-2 border-b border-white/5 ${
                  location.pathname === link.path ? "text-primary" : "text-muted"
                }`}
              >
                {link.name}
              </a>
            ))}
            <div className="pt-4">
              {!user || !user.email ? (
                <a
                  href="/login"
                  className="btn-primary w-full flex justify-center items-center gap-2"
                >
                  <FiUser /> Sign In
                </a>
              ) : (
                <button
                  onClick={handleLogout}
                  className="w-full flex justify-center items-center gap-2 text-red-400 py-3 rounded-lg bg-white/5"
                >
                  <FiLogOut /> Logout
                </button>
              )}
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
